export default {
    state: {
        classrooms: {
            headers:[
                { text: 'Classroom Name', align: 'center', sortable: false, value: 'name' },
                { text: 'Classroom Description', align: 'center', sortable: false, value: 'description' },
                // { text: 'Course', align: 'center', sortable: false, value: 'course_name' },
                { text: 'Classroom ID', align: 'center', sortable: false, value: 'course_id' },
            ]
        },
        courseWork: {
            headers: [
                { text: 'Course Work Name', align: 'center', sortable: false, value: 'coursework_name' },
                { text: 'Course Work Description', align: 'center', sortable: false, value: 'description' },
                { text: 'Course ID', align: 'center', sortable: false, value: 'course_name' },
                { text: 'Course Work Topic ID', align: 'center', sortable: false, value: 'topic_id' },
                { text: 'Course Work State', align: 'center', sortable: false, value: 'state' },
            ]
        },
        grades: {
            headers: [ //Student Email	Course Name	Course Work Name/ Module Name	Draft Grade	Assigned Grade	Course Alias
                { text: 'Student Email', align: 'center', sortable: false, value: 'email' },
                { text: 'Course Name', align: 'center', sortable: false, value: 'course_name' },
                { text: 'CourseWork Name/Module Name', align: 'center', sortable: false, value: 'coursework_name' },
                { text: 'Grade', align: 'center', sortable: false, value: 'grade' },
            ]
        },
        topics: {
            headers: [
                { text: 'Topic ID', align: 'center', sortable: false, value: 'id' },
                { text: 'Topic Name', align: 'center', sortable: false, value: 'name' },
                { text: 'Course Name', align: 'center', sortable: false, value: 'course_name' },
            ]
        },
        teacher: {
            headers: [
                { text: 'Courses', align: 'center', sortable: false, value: 'name' },
                { text: 'Teacher', align: 'center', sortable: false, value: 'teacher' },
            ]
        },
        student: {
            headers: [
                { text: 'Courses', align: 'center', sortable: false, value: 'name' },
                { text: 'Student', align: 'center', sortable: false, value: 'student' },
            ]
        },
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    }
}